<template>
  <Dropdown
    :trigger-style="`${selectedQuickFilters.length || selectedUrgentFilters.length || customFilter.length ? '!bg-[#38aa90bb] text-white !border-[#38aa90bb] !hover:bg-[#38aa90bb]' : ''} text-sm px-2 py-2 h-max font-medium text-[#282727] border-[1px] border-[#ACACAC] bg-white rounded-[10px] w-max  hover:bg-gray-100`"
    :close-on-outside-click="true"
  >
    <template #trigger>
      <button class="flex items-center justify-between gap-3">
        <span class="flex gap-1 items-center justify-between">
          <FunnelIcon class="size-5" />
          Filter
        </span>
        <span
          class="bg-transparent"
          v-if="selectedQuickFilters.length || selectedUrgentFilters.length || customFilter.length"
          @click.stop="clearFilters"
        >
          <XMarkIcon class="size-4" />
        </span>
      </button>
    </template>
    <template #contents>
      <div
        class="px-4 py-3 min-h-[100px] rounded-lg shadow-xl flex flex-col gap-4 w-full max-w-[35vw]"
        :class="props.currentMode == 'calendar' ? 'min-w-[35vw]' : ''"
      >
        <div class="flex w-full justify-between items-center gap-2">
          <h3 class="text-md font-semibold text-black outline-none">Filters</h3>
          <button
            class="bg-transparent text-gray-400 text-sm outline-none"
            v-if="selectedQuickFilters.length || selectedUrgentFilters.length || customFilter.length"
            @click.stop="clearFilters"
          >
            Clear
          </button>
        </div>
        <div class="flex flex-col gap-2 w-full presets items-start">
          <template v-if="filterPresets.length">
            <h3 class="bg-transparent text-gray-400 text-sm outline-none">Quick Filters</h3>
            <div class="flex gap-2 items-center w-full flex-wrap">
              <label
                :for="`${filter.key}_${filterIndex}`"
                class="px-2 py-1 border-[1px] border-gray-400 rounded-[20px] flex gap-1 items-center cursor-pointer"
                v-for="(filter, filterIndex) in filterPresets"
                :key="filterIndex"
              >
                <input
                  type="checkbox"
                  class="hidden"
                  :id="`${filter.key}_${filterIndex}`"
                  :value="filter.value"
                  :checked="selectedQuickFilters.includes(String(filter.value))"
                  @change="getQuickFilterData(String(filter.value), $event)"
                />
                <CheckIcon
                  class="size-4 border-[1px] border-gray-400 rounded-full text-gray-400 pointer-events-none"
                />
                <span class="text-sm whitespace-nowrap" v-html="sanitize(filter.label)"></span>
              </label>
              <template v-if="props.currentMode !== 'calendar'">
                <label
                  :for="`${urgentFilter.key}_${urgentIndex}`"
                  class="px-2 py-1 border-[1px] border-gray-400 rounded-[20px] flex gap-1 items-center cursor-pointer"
                  v-for="(urgentFilter, urgentIndex) in filterUrgentOrders"
                  :key="urgentIndex"
                >
                  <input
                    type="checkbox"
                    class="hidden"
                    :id="`${urgentFilter.key}_${urgentIndex}`"
                    :value="urgentFilter.value"
                    :checked="selectedUrgentFilters.includes(String(urgentFilter.value))"
                    @change="getUrgentOrderFilters(String(urgentFilter.value), $event)"
                  />
                  <CheckIcon
                    class="size-4 border-[1px] border-gray-400 rounded-full text-gray-400 pointer-events-none"
                  />
                  <span class="text-sm whitespace-nowrap" v-html="sanitize(urgentFilter.label)"></span>
                </label>
              </template>
            </div>
          </template>
          <template v-if="customFilter.length > 0">
            <h3 class="bg-transparent text-gray-400 text-sm outline-none mt-4">All Filters</h3>
            <div class="flex gap-2 items-start w-full flex-col">
              <template v-for="(filter, filterIndex) in customFilter" :key="filterIndex">
                <div class="flex gap-2 items-center w-full">
                  <Select
                    :options="
                      computedFilterList.filter(
                        (opt) => !selectedAllFilter.some((f) => f.key === opt.key)
                      )
                    "
                    track-by="key"
                    label="label"
                    class="min-w-[150px]"
                    v-model="selectedAllFilter[filterIndex]"
                    append-to-body
                    @option:selected="
                      (option: CustomFilter) => {
                        const resetFilter = { ...option };
                        if (resetFilter.type === 'multi-select') {
                          resetFilter.value = [];
                        } else if (resetFilter.type === 'autocomplete') {
                          resetFilter.value = [];
                        } else if (resetFilter.type === 'date-range') {
                          resetFilter.value = { from: '', to: '' };
                        } else {
                          resetFilter.value = '';
                        }
                        customFilter[filterIndex] = JSON.parse(JSON.stringify(resetFilter));
                        selectedAllFilter[filterIndex] = JSON.parse(JSON.stringify(resetFilter));
                      }
                    "
                    :clearable="false"
                    style="width: fit-content"
                  />
                  <template v-if="!['date', 'date-range'].includes(filter.type)">
                    <Select
                      :options="[
                        { label: 'is', value: 'equal' },
                        { label: 'is not', value: 'not_equal' }
                      ]"
                      track-by="value"
                      label="label"
                      v-model="filter.comparison"
                      :reduce="(option) => option.value"
                      :clearable="false"
                      class="min-w-[100px] max-w-[100px]"
                      append-to-body
                    />
                  </template>
                  <template v-if="filter.type === 'multi-select'">
                    <Select
                      :options="filter.options"
                      track-by="key"
                      label="label"
                      append-to-body
                      v-model="filter.value"
                      class="flex-1"
                      multiple
                    />
                  </template>
                  <template v-if="filter.type === 'single-select'">
                    <Select
                      :options="filter.options"
                      track-by="key"
                      label="label"
                      append-to-body
                      v-model="filter.value"
                      class="flex-1"
                    />
                  </template>

                  <template v-if="filter.type === 'autocomplete'">
                    <Select
                      :options="filter.options"
                      track-by="value"
                      label="label"
                      append-to-body
                      v-model="filter.value"
                      class="flex-1"
                      :filterable="false"
                      :clearable="true"
                      @search="
                        async (e: string, loading: any) => {
                          loading(true);
                          await fetchCustomers(e);
                          loading(false);
                        }
                      "
                      :multiple="true"
                    />
                  </template>

                  <template v-if="filter.type === 'string'">
                    <input
                      type="text"
                      v-model="filter.value"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 py-[7px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                  </template>
                  <template v-if="filter.type === 'date'">
                    <input
                      type="date"
                      v-model="filter.value"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 min-h-[3rem] py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                  </template>
                  <template
                    v-if="
                      filter.type === 'date-range' &&
                      typeof filter.value !== 'string' &&
                      !isArray(filter.value)
                    "
                  >
                    <input
                      type="date"
                      placeholder="From Date"
                      v-model="filter.value.from"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 min-h-[3rem] py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                    <input
                      type="date"
                      placeholder="To date"
                      v-model="filter.value.to"
                      class="flex-1 outline-none border-[1px] border-gray-400 rounded-[4px] px-2 min-h-[3rem] py-[3px] focus:outline-none focus:ring focus:ring-[#00b08760] duration-300 focus:border-[#00b08760]"
                    />
                  </template>
                  <button @click="removeFilter(filterIndex)">
                    <XMarkIcon class="size-4" />
                  </button>
                </div>
              </template>
            </div>
          </template>
        </div>

        <Dropdown
          trigger-style="text-sm px-2 py-2 h-max font-medium text-[#282727] border-[1px] border-[#ACACAC] bg-white rounded-[10px] w-max hover:bg-gray-100"
          :close-on-outside-click="true"
          :close-on-select="true"
          v-if="computedFilterList.length"
        >
          <template #trigger>
            <span class="flex items-center justify-between gap-3">
              <span class="flex gap-1 items-center justify-between">
                <PlusIcon class="size-5" />
                Add Filter
              </span>
              <span class="bg-transparent">
                <ChevronDownIcon class="size-4" />
              </span>
            </span>
          </template>

          <template #contents>
            <ul>
              <li
                class="px-2 py-2 text-[#292D32] cursor-pointer duration-300 hover:bg-[#F4F4F4] flex items-center justify-between gap-2"
                v-for="(filter, filterIndex) in computedFilterList"
                @click="addFilter(filter)"
                :key="filterIndex"
              >
                {{ filter.label }}
              </li>
            </ul>
          </template>
        </Dropdown>
      </div>
    </template>
  </Dropdown>
</template>
<script setup lang="ts">
import { can } from '@/composables';
import { handleResponseException, http } from '@/interceptors/axiosRequestInterceptor';
import { DashboardRequest } from '@/models';
import { useMainStore } from '@/store';
import {
  CheckIcon,
  ChevronDownIcon,
  FunnelIcon,
  PlusIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import { isArray } from 'lodash';
import { storeToRefs } from 'pinia';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import Dropdown from '../Shared/Dropdown.vue';
import Select from '../Shared/Select.vue';
import { orderTypes } from '@/utils/constants/orderTypes';
import { SHIPPING_STATUSES } from '@/utils/constants/shippingStatuses';
import { sanitize } from '@/utils/sanitize';

const CUSTIMOO_STATUSES: Record<string, string> = {
  quote_requested: 'Quote Requested',
  quote_rejected: 'Quote Rejected',
  quote_provided: 'Quote Provided',
  submitted_for_factory_review: 'Submitted for Factory Review',
  order_cancel: 'Cancelled',
  order_approve: 'Mark to Factory',
  factory_approved: 'Factory Approved',
  factory_rejected: 'Factory Rejected',
  submitted_for_customer_review: 'Submitted for Customer Review',
  customer_approved: 'Customer Approved',
  customer_rejected: 'Customer Rejected',
  in_production: 'In Production',
  shipped: 'Shipped',
  completed: 'Completed',
  pending_for_factory_assignment: 'Pending For Factory Assignment',
  production_files_uploaded: 'Production Files Uploaded',
};
/** Matches `order_items.invoice_composite_status` (partial invoicing ledger). */
const ORDER_INVOICE_COMPOSITE_STATUSES: Record<string, string> = {
  not_invoiced: 'Not invoiced',
  partially_invoiced: 'Partially invoiced',
  invoiced: 'Invoiced',
  partially_paid: 'Partially paid',
  paid: 'Paid',
  overdue: 'Overdue',
  uncollectible: 'Uncollectible',
  /** Stripe / old ledger: no automatic collection — matches item invoice status `manual`. */
  manual: 'Manual',
};
type ComparisonOp = 'equal' | 'not_equal';

interface CustomFilter {
  key: string;
  label: string;
  type: 'string' | 'single-select' | 'multi-select' | 'date' | 'autocomplete' | 'date-range';
  value: any;
  comparison?: ComparisonOp;
  options?: { label: string; value: any }[];
}

interface Filter {
  key: string;
  label: string;
  value: string | Array<string> | Record<'to' | 'from', string>;
  isPreset?: boolean;
}

interface Customer {
  label: string;
  value: number | string | Array<string> | Record<'to' | 'from', string>;
}

const emits = defineEmits(['updateFilter']);
const props = defineProps<{
  currentTab: string;
  currentMode: string;
}>();
if (can('view-onhold-orders')) {
  CUSTIMOO_STATUSES['on_hold'] = 'On Hold';
}
const store = useMainStore();
const {
  permissionLoaded,
  orderAdmins,
  csManagers,
  merchantUsers,
  dashboardQuickFilters,
  factories,
  salesRepresentatives,
  shops,
} = storeToRefs(useMainStore());
const currentDashboardModel = localStorage.getItem('dashboardRequest');
const current_filters = ref<DashboardRequest | undefined>(
  currentDashboardModel ? JSON.parse(currentDashboardModel).dashboardRequest : undefined
);
if (current_filters.value && typeof current_filters.value === 'string') {
  current_filters.value = JSON.parse(current_filters.value).dashboardRequest;
}

const selectedAllFilter = ref<CustomFilter[]>([]);
const selectedQuickFilters = ref<string[]>([]);
const selectedUrgentFilters = ref<string[]>([]);
const customFiltersHydrated = ref(false);

function normalizePresetArray(v: unknown): string[] {
  if (v == null || v === '') return [];
  if (Array.isArray(v)) return v.map((x) => String(x));
  return [String(v)];
}

onMounted(async () => {
  const savedQuickFilters = localStorage.getItem('dashboardQuickFilters');
  if (savedQuickFilters) {
    const quickFiltersObj = JSON.parse(savedQuickFilters);
    const quickVals: string[] = [];
    if (quickFiltersObj.filter_by) {
      quickVals.push(...normalizePresetArray(quickFiltersObj.filter_by));
    }
    if (quickFiltersObj.items_for) {
      quickVals.push(...normalizePresetArray(quickFiltersObj.items_for));
    }
    selectedQuickFilters.value = quickVals;
    if (quickFiltersObj.urgent_order) {
      selectedUrgentFilters.value = normalizePresetArray(quickFiltersObj.urgent_order);
    }
    if (Object.keys(quickFiltersObj).length > 0) {
      emits('updateFilter', {
        quick_filters: quickFiltersObj,
      });
    }
  }
  await store.getAllMerchants();
  if (can('filter-shops')) {
    await store.getAllShops();
  }
  watch(
    allFilters,
    (filters) => {
      const savedQuickFilters = localStorage.getItem('dashboardQuickFilters');
      if (filters.length === 0) {
        if (!savedQuickFilters) {
          customFilter.value = [];
          selectedAllFilter.value = [];
          customFiltersHydrated.value = true;
        }
        return;
      }
      if (savedQuickFilters) {
        try {
          const quickFiltersObj = JSON.parse(savedQuickFilters);
          const customKeys = Object.keys(quickFiltersObj).filter(
            (key) => key !== 'filter_by' && key !== 'urgent_order' && key !== 'items_for'
          );
          const restoredFilters = [];
          customKeys.forEach((key) => {
          const filterDef = filters.find((f) => f.key === key);
          if (!filterDef) return;
        
          let savedValue = quickFiltersObj[key]; // { comparison, values }
        
          // For multi-select, map the array of values to option objects
          if (
            filterDef.type === 'multi-select' &&
            savedValue &&
            Array.isArray(savedValue.values)
          ) {
            savedValue = {
              ...savedValue,
              values: savedValue.values.map((val) => {
                if (typeof val === 'object' && val !== null && 'value' in val)
                  return val;
                const opt = filterDef.options?.find((o) => o.value === val);
                return opt || { label: val, value: val };
              }),
            };
          }
        
          // Assign both comparison and values
          const filterClone = { ...filterDef, ...savedValue, value: savedValue.values || [] };
          restoredFilters.push(filterClone);
          });
          customFilter.value = restoredFilters;
          selectedAllFilter.value = restoredFilters.map((f) => ({ ...f }));
        } catch {}
      } else if (!savedQuickFilters) {
        customFilter.value = [];
        selectedAllFilter.value = [];
      }
      customFiltersHydrated.value = true;
    },
    { immediate: true }
  );
});

const filterPresets = ref<Filter[]>([]);
const filterUrgentOrders = ref<Filter[]>([]);
const allFilters = ref<CustomFilter[]>([]);
const customFilter = ref<CustomFilter[]>([]);
const customers = ref<Customer[]>([]);

const computedFilterList = computed(() => {
  if (props.currentMode === 'calendar') {
    return allFilters.value.filter(
      (filter) =>
        filter.key === 'customers' ||
        filter.key === 'merchants' ||
        filter.key === 'factory_ids' ||
        filter.key === 'order_admins' ||
        filter.key === 'csmanager' ||
        filter.key === 'sales_representative'
    );
  }
  return allFilters.value.filter((filter) => !customFilter.value.find((f) => f.key === filter.key));
});
function buildQuickFiltersObj(
  customFilterArr: CustomFilter[],
  presetGroups: Record<string, string[]>
) {
  const quickFiltersObj: Record<string, any> = {};

  Object.entries(presetGroups).forEach(([key, values]) => {
    if (values && values.length > 0) {
      quickFiltersObj[key] = values;
    }
  });

  customFilterArr.forEach((f) => {
    if (
      f.value === null ||
      f.value === undefined ||
      f.value === '' ||
      (Array.isArray(f.value) && f.value.length === 0)
    ) {
      return;
    }

    if (
      f.type === 'date-range' &&
      typeof f.value === 'object' &&
      f.value?.from &&
      f.value?.to
    ) {
      quickFiltersObj[f.key] = {
        comparison: f.comparison ?? 'equal',
        values: { from: f.value.from, to: f.value.to },
      };
      return;
    }

    if (Array.isArray(f.value)) {
      quickFiltersObj[f.key] = {
        comparison: f.comparison ?? 'equal',
        values: f.value.map((v) =>
          typeof v === 'object' && v !== null && 'value' in v ? v.value : v
        ),
      };
      return;
    }

    quickFiltersObj[f.key] = {
      comparison: f.comparison ?? 'equal',
      values: f.value,
    };
  });

  return quickFiltersObj;
}






function buildPresetGroupsFromSelections(): Record<string, string[]> {
  const groups: Record<string, string[]> = {};
  selectedQuickFilters.value.forEach((val) => {
    const def = filterPresets.value.find((f) => String(f.value) === val);
    if (!def) return;
    if (!groups[def.key]) groups[def.key] = [];
    groups[def.key].push(val);
  });
  const urgentPresets = Array.isArray(filterUrgentOrders.value) ? filterUrgentOrders.value : [];
  selectedUrgentFilters.value.forEach((val) => {
    const def = urgentPresets.find((f) => String(f.value) === val);
    if (!def) return;
    if (!groups[def.key]) groups[def.key] = [];
    groups[def.key].push(val);
  });
  return groups;
}

const getQuickFilterData = (value: string, e: Event) => {
  const el = e.target as HTMLInputElement;
  if (el.checked) {
    if (!selectedQuickFilters.value.includes(value)) {
      selectedQuickFilters.value = [...selectedQuickFilters.value, value];
    }
  } else {
    selectedQuickFilters.value = selectedQuickFilters.value.filter((v) => v !== value);
  }
};

const getUrgentOrderFilters = (value: string, e: Event) => {
  const el = e.target as HTMLInputElement;
  if (el.checked) {
    if (!selectedUrgentFilters.value.includes(value)) {
      selectedUrgentFilters.value = [...selectedUrgentFilters.value, value];
    }
  } else {
    selectedUrgentFilters.value = selectedUrgentFilters.value.filter((v) => v !== value);
  }
};

const clearFilters = async () => {
  selectedQuickFilters.value = [];
  selectedUrgentFilters.value = [];
  dashboardQuickFilters.value = null;
  customFilter.value = [];
  selectedAllFilter.value = [];
  localStorage.removeItem('dashboardQuickFilters');
  emits('updateFilter', {});
};
const addFilter = (filter: CustomFilter): void => {
  const filterClone = JSON.parse(JSON.stringify(filter));
  selectedAllFilter.value = [...selectedAllFilter.value, filterClone];
  customFilter.value = [...customFilter.value, filterClone];
};
const removeFilter = async (index: number): Promise<void> => {
  selectedAllFilter.value = selectedAllFilter.value.filter((_, i) => i !== index);
  customFilter.value = customFilter.value.filter((_, i) => i !== index);
  await nextTick();
};
const getFilterPresets = (): Filter[] => {
  if (props.currentMode === 'calendar') {
    return [
      can('show-my-assign-orders') && {
        label: 'My Assigned Orders',
        value: 'my_assigned_orders',
        key: 'items_for',
        isPreset: true,
      },
    ].filter(Boolean);
  }

  const presets: Filter[] = [
    can('can-resolve-comment') && {
      label: 'Unresolved Comments',
      value: 'unresolved_comments',
      key: 'filter_by',
      isPreset: true,
    },
    {
      label: 'Reorders',
      value: 'reorders',
      key: 'filter_by',
      isPreset: true,
    },
    {
      label: `<p>Awaiting Customer Feedback</p>`,
      value: 'customer_await_items',
      key: 'filter_by',
      isPreset: true,
    },
    can('filter-factory-pi') && {
      label: `<p>Factory PI</p>`,
      value: 'factory_pi',
      key: 'filter_by',
      isPreset: true,
    },
    can('show-order-admin-assigned') && {
      label: `<p>No Order Admin Assigned</p>`,
      value: 'no_order_admin',
      key: 'filter_by',
      isPreset: true,
    },
    can('show-factory-filter') && {
      label: `<p>Awaiting Factory Actions</p>`,
      value: 'pending_items',
      key: 'filter_by',
      isPreset: true,
    },
    can('view-samples') && {
      label: `<p>Samples</p>`,
      value: 'samples',
      key: 'filter_by',
      isPreset: true,
    },
    {
      label: `<p>Quote Requested</p>`,
      value: 'quote_requested_items',
      key: 'filter_by',
      isPreset: true,
    },
    {
      label: `<p>Open</p>`,
      value: 'open_orders',
      key: 'filter_by',
      isPreset: true,
    },
    {
      label: `<p>Shop in shop order</p>`,
      value: 'is_shop_order',
      key: 'filter_by',
    },
    (can('read-dqc-status') || can('write-dqc-status')) && {
      label: `<p>DQC Approved</p>`,
      value: 'marked_dqc',
      key: 'filter_by',
      isPreset: true,
    },
    (can('read-dqc-status') || can('write-dqc-status')) && {
      label: `<p>DQC Not Approved</p>`,
      value: 'not_marked_dqc',
      key: 'filter_by',
      isPreset: true,
    },
  ].filter((item) => typeof item !== 'boolean');

  return presets;
};

const getFilterUrgentOrders = (): Filter[] => {
  return [
    {
      label: `<p class="flex flex-row justify-between items-center gap-x-4"> <span>Extra Attention</span> <span class="rounded-full bg-blue-300 px-[10px] py-[10px]"></span></p>`,
      value: 'extra_attention',
      key: 'urgent_order',
      isPreset: true,
    },
    {
      label: `<p class="flex flex-row justify-between items-center gap-x-4"> <span>Urgent</span> <span class="rounded-full order_cancel px-[10px] py-[10px]"></span></p>`,
      value: 'urgent',
      key: 'urgent_order',
      isPreset: true,
    },
    {
      label: `<p class="flex flex-row justify-between items-center gap-x-4"> <span>VIP</span> <span class="rounded-full bg-green-300 px-[10px] py-[10px]"></span></p>`,
      value: 'vip',
      key: 'urgent_order',
      isPreset: true,
    },
  ].filter((item) => typeof item !== 'boolean');
};

const getAllFilters = (): CustomFilter[] => {
  const filters: CustomFilter[] = [
    {
      key: 'status',
      label: 'Status',
      type: 'multi-select',
      value: [],
      comparison: 'equal' as ComparisonOp,
      options: Object.keys(CUSTIMOO_STATUSES).map((key) => ({
        label: CUSTIMOO_STATUSES[key],
        value: key,
      })),
    },
    ...(can('view-payment-status')
      ? [
          {
            key: 'invoice_composite_status',
            label: 'Invoice Status',
            type: 'multi-select' as const,
            value: [],
            comparison: 'equal' as ComparisonOp,
            options: Object.keys(ORDER_INVOICE_COMPOSITE_STATUSES).map((key) => ({
              label: ORDER_INVOICE_COMPOSITE_STATUSES[key],
              value: key,
            })),
          },
        ]
      : []),
    {
      key: 'shipping_status',
      label: 'Shipping Status',
      type: 'multi-select',
      value: [],
      comparison: 'equal' as ComparisonOp,
      options: Object.keys(SHIPPING_STATUSES).map((key) => ({
        label: SHIPPING_STATUSES[key],
        value: key,
      })),
    },
    {
      key: 'created_at',
      label: 'Order Creation',
      type: 'date-range',
      value: {
        to: '',
        from: '',
      },
      comparison: 'equal' as ComparisonOp, 
    },
    ...(can('order_administrator_list')
      ? [
          {
            key: 'order_admins',
            label: 'Order Admins',
            type: 'multi-select' as const,
            value: [],
            comparison: 'equal' as ComparisonOp, 
            options: orderAdmins.value.map((admin) => ({
              label: admin.name,
              value: admin.id,
            })),
          },
        ]
    : []),
    ...(can('order_administrator_list')
      ? [
          {
            key: 'secondary_order_admins',
            label: 'Secondary Admins',
            type: 'multi-select' as const,
            value: [],
            comparison: 'equal' as ComparisonOp, 
            options: orderAdmins.value.map((admin) => ({
              label: admin.name,
              value: admin.id,
            })), 
          },
        ]
    : []),
    ...(can('order_csmanager_list')
      ? [
          {
            key: 'csmanager',
            label: 'Customer Success Manager',
            type: 'multi-select' as const,
          value: [],
          comparison: 'equal' as ComparisonOp, 
            options: csManagers.value.map((admin) => ({
              label: admin.name,
              value: admin.id,
            })),
          },
        ]
      : []),
    ...(can('order_sales_representative_list')
      ? [
          {
            key: 'sales_representative',
            label: 'Sales Representative',
            type: 'multi-select' as const,
          value: [],
         comparison: 'equal' as ComparisonOp, 
            options: salesRepresentatives.value.map((admin) => ({
              label: admin.name,
              value: admin.id,
            })),
          },
        ]
      : []),
    {
      key: 'customers',
      label: 'Customer',
      type: 'autocomplete',
      value: [],
      comparison: 'equal' as ComparisonOp, 
      options: customers.value.map((customer) => ({
        label: customer.label,
        value: customer.value,
      })),
    },
    ...(can('merchants_list')
      ? [
          {
            key: 'merchants',
            label: 'Merchant',
            type: 'multi-select' as const,
            value: [],
           comparison: 'equal' as ComparisonOp, 
            options: merchantUsers.value.map((merchant) => ({
              label: merchant.company_name,
              value: merchant.id,
            })),
          },
        ]
      : []),
    // filter for shops
    ...(can('filter-shops')
      ? [
          {
            key: 'shop',
            label: 'Shop',
            type: 'multi-select' as const,
            value: '',
            comparison: 'equal' as ComparisonOp,
            options: shops.value.map((shop) => ({
              label: shop.name,
              value: shop.id,
            })),
          },
        ]
      : []),
    ...(can('order-types-filter')
      ? [
          {
            key: 'order_types',
            label: 'Order Types',
            type: 'multi-select' as const,
            value: [],
           comparison: 'equal' as ComparisonOp, 
            options: orderTypes.map((type) => ({
              label: type.label,
              value: type.symbol,
            })),
          },
        ]
      : []),
  ];

  if (
    props.currentMode === 'calendar' &&
    factories.value.length > 0 &&
    can('show-factory-filter')
  ) {
    filters.push({
      key: 'factory_ids',
      label: 'Factory',
      type: 'multi-select',
      value: [],
     comparison: 'equal' as ComparisonOp, 
      options: factories.value.map((factory) => ({
        label: factory.name,
        value: factory.id,
      })),
    });
  }
  if(can('view-po-filter')) {
    filters.push({
      key: 'po_number',
      label: 'PO',
      type: 'string',
      value: '',
    });
  }

  filters.push({
    key: 'invoice_number',
    label: 'Invoice Number',
    type: 'string',
    value: '',
    comparison: 'equal' as ComparisonOp,
  });

  if (
    props.currentMode != 'calendar' &&
    factories.value.length > 0 &&
    can('show-factory-filter-table-view')
  ) {
    filters.push({
      key: 'factory_filter_ids',
      label: 'Factory',
      type: 'multi-select',
      value: [],
      options: factories.value.map((factory) => ({
        label: factory.name,
        value: factory.id,
      })),
    });
  }

  return filters;
};

watch(
  [
    () => permissionLoaded.value,
    () => props.currentTab,
    () => merchantUsers.value,
    () => orderAdmins.value,
    () => csManagers.value,
    () => salesRepresentatives.value,
    () => props.currentMode,
  ],
  (newVal) => {
    if (newVal) {
      filterPresets.value = getFilterPresets();
      filterUrgentOrders.value = can('show-urgency-filters') ? getFilterUrgentOrders() : [];
      if (
        current_filters.value &&
        filterPresets.value.some(
          (filter: Filter) =>
            filter.value === (current_filters.value ? current_filters.value.items_for : '')
        )
      ) {
        let skipTabPresetSync = false;
        try {
          const raw = localStorage.getItem('dashboardQuickFilters');
          if (raw) {
            const o = JSON.parse(raw);
            if (
              normalizePresetArray(o.filter_by).length > 0 ||
              normalizePresetArray(o.items_for).length > 0
            ) {
              skipTabPresetSync = true;
            }
          }
        } catch {
          /* ignore */
        }
        if (!skipTabPresetSync) {
          selectedQuickFilters.value = [String(current_filters.value.items_for)];
        }
      }
      allFilters.value = getAllFilters();
    }
  },
  { deep: true }
);

const fetchCustomers = async (query: string): Promise<boolean> => {
  if (!query || query.length < 3) {
    customers.value = [];
    return true;
  }

  try {
    const resp = await http.post(`/search-customers`, { query });
    const autoCompleteFilter = customFilter.value.find((filter) => filter.key === 'customers');
    if (autoCompleteFilter) {
      autoCompleteFilter.options = [
        ...resp.data.result.map((customer: any) => ({
          label: `${customer.full_name}`,
          value: `${customer.email}`,
        })),
      ];
    }
    return true;
  } catch (e: any) {
    handleResponseException(e);
    return true;
  }
};

watch(
  [customFilter, selectedQuickFilters, selectedUrgentFilters, filterPresets, filterUrgentOrders],
  ([newFilters]) => {
    const urgentList = Array.isArray(filterUrgentOrders.value) ? filterUrgentOrders.value : [];
    if (selectedQuickFilters.value.length > 0 && filterPresets.value.length === 0) {
      return;
    }
    if (selectedUrgentFilters.value.length > 0 && urgentList.length === 0) {
      return;
    }
    if (!customFiltersHydrated.value && (newFilters as CustomFilter[]).length === 0) {
      return;
    }
    const presetGroups = buildPresetGroupsFromSelections();
    const quickFiltersObj = buildQuickFiltersObj(newFilters as CustomFilter[], presetGroups);
    localStorage.setItem('dashboardQuickFilters', JSON.stringify(quickFiltersObj));
    emits('updateFilter', {
      quick_filters: quickFiltersObj,
    });
  },
  { deep: true }
);
</script>
<style lang="scss" scoped>
label {
  &:has(input[type='checkbox']:checked) {
    background: #eaebee;
    svg {
      background: #00b0877e;
      border-color: #00b0877e;
      path {
        fill: white;
      }
    }
  }
  user-select: none;
}
</style>